/** Shown in the legal footer — replace with the real support inbox. */
export const CONTACT_EMAIL = 'soporte@carpinteriaenaluminio.com'

export const BUSINESS_NAME = 'Super Combo Carpintería en Aluminio'

const UTM_PARAMS =
  'utm_source=facebook&utm_medium=paid&utm_campaign={{campaign.name}}&utm_term={{adset.name}}&utm_content={{ad.name}}&utm_id={{ad.id}}'

const BASE = 'https://super-combo-carpinteria-en-aluminio.impultienda.ar/checkout'

/** Two separate offers — never mix these links. */
export const CHECKOUT = {
  /** Super Combo · $19.990 */
  combo: `${BASE}/embudo-carp-alum?${UTM_PARAMS}`,
  /** Super Combo PRO · $26.990 */
  pro: `${BASE}/carp-alum-completo?${UTM_PARAMS}`,
}

export const PRICE = {
  combo: '$19.990',
  pro: '$26.990',
}

export const IMAGES = {
  heroMockup:
    'https://cdn.magicpatterns.com/uploads/j8f6vyZ4J5gyYwbQ3Wj9iT/ChatGPT_Image_10_sept_2026,_06_27_54_p.m..png',
  fabrication:
    'https://cdn.magicpatterns.com/patterns/generated-images/d600252a-d327-4b1b-84dd-845d817b99f6.jpg',
  proMasterCalc:
    'https://cdn.magicpatterns.com/patterns/generated-images/f630d718-1f6b-4414-a489-93aced6346be.jpg',
  proMasterGuide:
    'https://cdn.magicpatterns.com/patterns/generated-images/2deaa8b9-8316-43de-bbd4-1a92fbdba75b.jpg',
}

/* ------------------------------ 2 — Qué aprendés ------------------------------ */

export type Skill = {
  icon: string
  title: string
  text: string
}

export const skills: Skill[] = [
  {
    icon: '📐',
    title: 'Medí',
    text: 'Tomá correctamente las medidas.',
  },
  {
    icon: '✂️',
    title: 'Calculá',
    text: 'Trabajá cortes, descuentos y materiales.',
  },
  {
    icon: '🪟',
    title: 'Fabricá',
    text: 'Aprendé diferentes sistemas de aberturas.',
  },
  {
    icon: '💰',
    title: 'Presupuestá',
    text: 'Calculá costos y organizá tus presupuestos.',
  },
  {
    icon: '🔧',
    title: 'Instalá',
    text: 'Aprendé colocación, sellado y terminaciones.',
  },
]

/** Hero reassurance row — no price, no checkout on the first screen. */
export const heroBenefits = [
  'Desde cero',
  'Herrero, Módena y A30 New',
  'Fabricación e instalación',
  'Costos y presupuestos',
]

/* ----------------------------- 3 — Qué recibís ------------------------------- */

export type Tomo = {
  number: string
  title: string
  image: string
  alt: string
}

export const tomos: Tomo[] = [
  {
    number: '01',
    title: 'Fundamentos & Línea Herrero',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5ab2294f-49c9-4303-b47f-d9e9cc0e6cb2.jpg',
    alt: 'Tapa del Tomo 1: Fundamentos y Línea Herrero',
  },
  {
    number: '02',
    title: 'Línea Módena',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/41ed388c-3d0a-4841-942f-ca97a4a156fb.jpg',
    alt: 'Tapa del Tomo 2: Línea Módena',
  },
  {
    number: '03',
    title: 'A30 New & DVH',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1557fb29-cb3c-4c89-9941-5ee7970516e5.jpg',
    alt: 'Tapa del Tomo 3: A30 New y DVH',
  },
  {
    number: '04',
    title: 'Cortes, Descuentos & Fórmulas',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bd5f21fc-f0c7-486a-b52e-99134ff4c0b8.jpg',
    alt: 'Tapa del Tomo 4: Cortes, Descuentos y Fórmulas',
  },
  {
    number: '05',
    title: 'Presupuestador PRO',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c7cf7b78-9ef6-4d80-ae42-159c9ad79736.jpg',
    alt: 'Tapa del Tomo 5: Presupuestador PRO',
  },
  {
    number: '06',
    title: 'Instalación & Service',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/38796f47-9b02-48cb-83b5-aac9a78928ae.jpg',
    alt: 'Tapa del Tomo 6: Instalación y Service',
  },
]

export const bonos = [
  'Lista Maestra de Compras',
  'Mensajes que Cierran Trabajos',
  'Checklist Medición Perfecta',
  'Pack Croquis Listos',
  'Guía Control de Calidad',
  'Tracker Costos y Ganancia',
]

/* ---------------------------- 4 — Mirá el interior --------------------------- */

export const insidePages = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bb9dc370-40af-4065-9cf6-6124d06323ad.jpg',
    caption: 'Tablas y fórmulas',
    alt: 'Página interior con tabla de descuentos de corte para perfiles de aluminio',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c6b80429-164a-4319-8eb9-bbee51167acb.jpg',
    caption: 'Croquis',
    alt: 'Croquis técnico acotado de una ventana corrediza de aluminio',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2d1cdd5d-2558-4835-a524-1cea79133d7c.jpg',
    caption: 'Checklists',
    alt: 'Checklist impreso de medición en obra con casilleros marcados',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9c0c24be-def9-4261-a121-33d78fef6158.jpg',
    caption: 'Paso a paso',
    alt: 'Secuencia de armado paso a paso de un marco de aluminio',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/967209fa-cf46-4bc0-91d8-9740497abd26.jpg',
    caption: 'Contenido práctico',
    alt: 'Página interior con tabla de referencia de herrajes y accesorios',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8dc67142-dadd-4d93-bb15-dd7c6497e9d1.jpg',
    caption: 'Ejemplos técnicos',
    alt: 'Planilla de presupuesto con filas de ítems, costos y totales',
  },
]

/* ------------------------------ 5 — Las ofertas ------------------------------ */

export const comboIncludes = [
  '6 Tomos',
  '6 Bonos',
  'Herrero, Módena y A30 New',
  'DVH',
  'Cortes y fórmulas',
  'Presupuestos',
  'Instalación & Service',
]

export const proProducts = [
  {
    icon: '🚀',
    title: 'Master-Calc & Diseño PRO',
    description:
      'Cálculo, diseño, soluciones constructivas, accesorios y contenido técnico avanzado.',
    image: IMAGES.proMasterCalc,
    alt: 'Mockup del pack Master-Calc & Diseño PRO',
  },
  {
    icon: '🏆',
    title: 'Master-Guide: Muebles & Diseño en Aluminio',
    description:
      'Ampliá lo aprendido hacia muebles, cocinas, exteriores, mamparas, divisores y barandas, con planos y listas de corte.',
    image: IMAGES.proMasterGuide,
    alt: 'Mockup de la guía Master-Guide Muebles & Diseño en Aluminio',
  },
]

/* --------------------------------- 6 — FAQ ----------------------------------- */

export const faqs = [
  {
    q: '¿Necesito experiencia?',
    a: 'No. El contenido comienza desde los fundamentos y avanza progresivamente.',
  },
  {
    q: '¿Qué recibo en el Super Combo?',
    a: '6 Tomos + 6 Bonos digitales.',
  },
  {
    q: '¿Qué agrega el Super Combo PRO?',
    a: 'Incluye todo el Super Combo y además Master-Calc & Diseño PRO + Master-Guide Muebles & Diseño en Aluminio.',
  },
  {
    q: '¿Cuál es la diferencia de precio?',
    a: `El Super Combo cuesta ${PRICE.combo} ARS y el Super Combo PRO ${PRICE.pro} ARS. La diferencia es de $7.000.`,
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí.',
  },
  {
    q: '¿El producto es digital?',
    a: 'Sí. El contenido se entrega digitalmente.',
  },
]
